import { createRouter, createWebHistory } from 'vue-router';

import lib from '@/lib';

import Layout from '@/layouts/Layout';

import AdminMain from '@/pages/admin/Main';
import AdminNews from '@/pages/admin/News';
import AdminNewsItemAdd from '@/pages/admin/NewsItemAdd';
import AdminNewsItemEdit from '@/pages/admin/NewsItemEdit';
import AdminProductsCategories from '@/pages/admin/ProductsCategories';
import AdminProductsCategoryAdd from '@/pages/admin/ProductsCategoryAdd';
import AdminProductsCategoryEdit from '@/pages/admin/ProductsCategoryEdit';
import AdminProducts from '@/pages/admin/Products';
import AdminProductAdd from '@/pages/admin/ProductAdd';
import AdminProductEdit from '@/pages/admin/ProductEdit';
import AdminCoupons from '@/pages/admin/Coupons';
import AdminCouponAdd from '@/pages/admin/CouponAdd';
import AdminCouponEdit from '@/pages/admin/CouponEdit';
import AdminUsers from '@/pages/admin/Users';

import Main from '@/pages/Main';
import Contacts from '@/pages/Contacts';
import Tracking from '@/pages/Tracking';
import About from '@/pages/About';
import Catalog from '@/pages/Catalog';
import CatalogItem from '@/pages/CatalogItem';
import News from '@/pages/News';
import NewsItem from '@/pages/NewsItem';
import Checkout from '@/pages/Checkout';
import CheckoutSuccess from '@/pages/CheckoutSuccess';
import Basket from '@/pages/Basket';
import Wishlist from '@/pages/Wishlist';
import Account from '@/pages/Account';
import Orders from '@/pages/Orders';
import Login from '@/pages/Login';
import Register from '@/pages/Register';

import PageNotFound from '@/pages/PageNotFound';

const routes = [
	/*{
		path: '/',
		redirect: '/index',
	},*/
	{
		path: '',
		component: Layout,
		children: [
			{
				path: '',
				component: Main,
			},
			{
				path: '/contacts',
				component: Contacts,
			},
			{
				path: '/tracking',
				component: Tracking,
			},
			{
				path: '/about',
				component: About,
			},
			{
				path: '/catalog',
				component: Catalog,
			},
			{
				path: '/catalog/:id',
				component: CatalogItem,
			},
			{
				path: '/basket',
				component: Basket,
			},
			{
				path: '/wishlist',
				component: Wishlist,
			},
			{
				path: '/news',
				component: News,
			},
			{
				path: '/news/:id',
				component: NewsItem,
			},
			{
				path: '/checkout',
				component: Checkout,
			},
			{
				path: '/checkout/success',
				component: CheckoutSuccess,
			},
			
			{
				path: '/account',
				component: Account,
				meta: {
					requiresAuth: true,
				},
			},
			{
				path: '/orders',
				component: Orders,
				meta: {
					requiresAuth: true,
				},
			},
			
			{
				path: '/login',
				component: Login,
				meta: {
					guest: true,
				},
			},
			{
				path: '/register',
				component: Register,
				meta: {
					guest: true,
				},
			},
			
			{
				path: '/admin',
				component: AdminMain,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/news',
				component: AdminNews,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/news/add',
				component: AdminNewsItemAdd,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/news/:id',
				component: AdminNewsItemEdit,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/products-categories',
				component: AdminProductsCategories,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/products-categories/add',
				component: AdminProductsCategoryAdd,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/products-categories/:id',
				component: AdminProductsCategoryEdit,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/products',
				component: AdminProducts,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/products/add',
				component: AdminProductAdd,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/products/:id',
				component: AdminProductEdit,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/coupons',
				component: AdminCoupons,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/coupons/add',
				component: AdminCouponAdd,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/coupons/:id',
				component: AdminCouponEdit,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
			{
				path: '/admin/users',
				component: AdminUsers,
				meta: {
					requiresAuth: true,
					admin: true,
				},
			},
		],
	},
	{
		path: '/logout',
		beforeEnter(to, from, next){
			const isAdmin = storeInstance.state.app.auth.isAdmin();
			storeInstance.state.app.auth.doLogout().then(() => {
				next({path: '/'});
			});
		},
	},
	{
		path: '/:pathMatch(.*)*',
		component: Layout,
		children: [
			{
				path: '',
				component: PageNotFound,
			},
		],
	},
	{
		path: '/:pathMatch(.*)',
		component: Layout,
		children: [
			{
				path: '',
				component: PageNotFound,
			},
		],
	},
];

const router = createRouter({
	history: createWebHistory(),
	routes,
});

router.beforeEach((to, from, next) => {
	storeInstance.state.app.auth.doInitData().then(() => {
		if(to.matched.some(record => record.meta.requiresAuth)){
			if(!storeInstance.state.app.auth.isAuth()){
				next({
					path: '/login',
					params: {
						nextUrl: to.fullPath,
					},
				})
			} else {
				next()
			}
		} else if(to.matched.some(record => record.meta.guest)){
			if(storeInstance.state.app.auth.isAuth()){
				next('/')
			} else {
				next()
			}
		} else {
			next() 
		}
	});
});

export default router;